module.exports = __webpack_public_path__ + "img/FullEarlyWeightBearingBenefits.1b4664e9.jpg";